import React from "react"
import { Navigate } from "react-router-dom"

import { useVenue } from "@/contexts/venue"

const RedirectToSlug: React.FC = () => {
  const { venue } = useVenue()

  return <Navigate to={`/panel/${venue.slug}`} replace />
}

export default RedirectToSlug
